import React from 'react';
import { useAuthenticator, useTheme, View, Heading, Authenticator } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify';

export const candidateForSave = () => {
  var errorElements = document.getElementsByClassName("cdm-field-error");
  return errorElements.length === 0;
};

export const formatDateFromMillis = (millis) => {
  if (millis) {
    const dateToFormat = new Date();
    dateToFormat.setTime(millis)
    return dateToFormat.toLocaleDateString("fr-FR");

  }
  return null;
};

export const isEmail = (email) => {
  if (email && email.trim() !== '') {
    return email.match(
      // eslint-disable-next-line
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
  return false;
}

export const checkPhoneNumber = (phone) => {
  // Format E.164 : +[code pays][numéro]
  const phoneRegex = /^\+[1-9]\d{1,14}$/;
  return phone ? !phoneRegex.test(phone) : false;
};

export const getCgu = (groups, cguAccepted) => {
  if(groups.includes('observateurs')) {
    return [];
  }
  const cguToShow = [];
  const scrbGroups = new Set(['scrb_gaz', 'scrb_clim', 'scrb_mazout', 'scrb_solide', 'scrb_pompe_chaleur']);
  if (groups.some(group => scrbGroups.has(group))) {
    if(!cguAccepted.includes('cgu_escrb')) {
      cguToShow.push('cgu_escrb');
    }
  }
  if (groups.some(group => ['gerants', 'superviseurs_apprentissage'].includes(group))) {
    if(!cguAccepted.includes('cgu_fi')) {
      cguToShow.push('cgu_fi');
    }
  }
  return cguToShow;
}

export const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <div className='cdm-logo'
        />
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();
    const { route } = useAuthenticator(context => [context.route]);
    return (
      <View padding={tokens.space.large}>
        {I18n.get("Besoin d'aide?")}<br />
        {I18n.get("Cliquez ")}<a style={{ color: '#000000' }} href={route !== 'confirmSignIn' ? I18n.get("https://www.cdm.lu/mediatheque/media/comment-realiser-ma-premiere-connexion") : I18n.get("https://www.cdm.lu/mediatheque/media/ou-trouver-mon-code-de-verification")} rel="noopener noreferrer" target="_blank"><b>{I18n.get("ici")}</b></a>{I18n.get(" pour consulter la vidéo explicative.")}
      </View>
    );
  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading
          padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
          level={3}
        >
          {I18n.get("Welcome")}
        </Heading>
      );
    },
  },
  ForceNewPassword: {
    FormFields() {
      return (
        <>
          {I18n.get("passwordpolicy")}
          <Authenticator.ForceNewPassword.FormFields />
        </>
      );
    },
  },
};

export const formFields = {
  setupTOTP: {
    QR: {
      totpIssuer: 'CdM myHandwierk',
    },
  },
}